import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { CtaSection } from '@/components/shared/cta-section'
import { Slider } from '@/components/shared/slider'

const About: FC = (): ReactNode => {
    return (
        <>
            <Seo
                title='Company'
                description='Meet the only platform your finance team needs, built by leaders in technology, automotive, and finance.'
            />

            {/* ---------------- Hero ---------------- */}
            <div className='section overflow-hidden'>
                <div className='container'>
                    <div className='top-margin-l'>
                        <div className='center-text'>
                            <div className='hero-text-holder'>
                                <div className='animate-on-load-1st'>
                                    <h1 className='hero-text'>Meet the only platform your finance team needs</h1>
                                </div>
                                <div className='animate-on-load-2st'>
                                    <div className='hero-paragraph'>
                                        <div className='w-layout-grid grid-8-col'>
                                            <p id='w-node-_9f6a1c31-cb87-d027-be61-0905060b67dc-8c3bb787'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. At etiam tellus aliquet risus, odio vitae cras viverra elementum.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='top-margin-l'>
                            <div className='slider-holder'>
                                <Slider
                                    ariaLabel='Product screenshots'
                                    slides={[
                                        <div key='s1' className='map-holder'>
                                            <img className='slider-image' src='/images/Slider-Image-3_1Slider-Image-3.webp' alt='' loading='lazy' />
                                        </div>,
                                        <div key='s2' className='map-holder'>
                                            <img src='/images/Slider-Image.webp' loading='lazy' alt='' className='slider-image' />
                                        </div>,
                                        <div key='s3' className='map-holder'>
                                            <img src='/images/Slider-Image-2_1Slider-Image-2.webp' loading='lazy' alt='' className='slider-image' />
                                        </div>
                                    ]}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='top-margin-m'>
                        <div id='w-node-_5bafd372-1aad-2c84-0e5c-8a343d65a316-8c3bb787' className='center-box'>
                            <div className='w-layout-grid grid-3-col'>
                                <div id='w-node-f19162a4-ac88-8d90-1a56-79a0764b110c-8c3bb787' className='black-box-holder about-box'>
                                    <div className='element-holder'>
                                        <div className='gradient-text-holder'>
                                            <div className='gradient-text-simple'>87%</div>
                                        </div>
                                        <div className='card-about-content'>Financial processes automated VC.</div>
                                    </div>
                                </div>
                                <div id='w-node-_741bd995-dd6a-bd0b-9915-04b41ca8d89c-8c3bb787' className='black-box-holder about-box'>
                                    <div className='element-holder'>
                                        <div className='gradient-text-holder'>
                                            <div className='gradient-text-simple'>24h</div>
                                        </div>
                                        <div className='card-about-content'>Work spared every single month</div>
                                    </div>
                                </div>
                                <div id='w-node-d4efdab2-c6fa-de5c-29a3-f6f058de07dc-8c3bb787' className='black-box-holder about-box'>
                                    <div className='element-holder'>
                                        <div className='gradient-text-holder'>
                                            <div className='gradient-text-simple'>2500€</div>
                                        </div>
                                        <div className='card-about-content'>Saved each month with automation</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ---------------- Team + investors ---------------- */}
            <div className='section overflow-hidden'>
                <div className='container'>
                    <div className='top-margin-xl'>
                        <div className='w-layout-grid grid-8-col'>
                            <div id='w-node-_64e0e0e3-5c82-16b5-7c2f-5824873f803d-8c3bb787' className='content'>
                                <div id='w-node-d184e0fb-fdcd-af09-8265-bc9705e08b60-8c3bb787' className='fade-in-move-on-scroll'>
                                    <div className='center-text'>
                                        <h2 className='hero-heading'>Built by leaders in the technology, automotive, and finance industries</h2>
                                        <p id='w-node-d184e0fb-fdcd-af09-8265-bc9705e08b61-8c3bb787'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. At etiam tellus aliquet risus, odio vitae cras viverra elementum.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='w-layout-grid team-grid'>
                        <div id='w-node-d184e0fb-fdcd-af09-8265-bc9705e08b65-8c3bb787' className='team-member-content-holder'><img src='/images/Team-Member-1.jpg' loading='lazy' alt='' className='team-image' />
                            <div className='name-heading-holder'>
                                <h5 className='team-member-name'>Brooke Cagle</h5>
                            </div>
                        </div>
                        <div id='w-node-d184e0fb-fdcd-af09-8265-bc9705e08b6a-8c3bb787' className='team-member-content-holder'><img src='/images/Team-Member-2.jpg' loading='lazy' alt='' className='team-image' />
                            <div className='name-heading-holder'>
                                <h5 className='team-member-name'>Lethicia Matos</h5>
                            </div>
                        </div>
                        <div id='w-node-d184e0fb-fdcd-af09-8265-bc9705e08b6f-8c3bb787' className='team-member-content-holder'><img src='/images/Team-Member-8.jpg' loading='lazy' alt='' className='team-image' />
                            <div className='name-heading-holder'>
                                <h5 className='team-member-name'>Jane Smith</h5>
                            </div>
                        </div>
                        <div id='w-node-d184e0fb-fdcd-af09-8265-bc9705e08b74-8c3bb787' className='team-member-content-holder'><img src='/images/Team-Member-6.jpg' loading='lazy' alt='' className='team-image' />
                            <div className='name-heading-holder'>
                                <h5 className='team-member-name'>Guilherme Stecanella</h5>
                            </div>
                        </div>
                        <div id='w-node-d184e0fb-fdcd-af09-8265-bc9705e08b79-8c3bb787' className='team-member-content-holder'><img src='/images/Team-Member-3.jpg' loading='lazy' alt='' className='team-image' />
                            <div className='name-heading-holder'>
                                <h5 className='team-member-name'>Warren Wong</h5>
                            </div>
                        </div>
                        <div id='w-node-d184e0fb-fdcd-af09-8265-bc9705e08b7e-8c3bb787' className='team-member-content-holder'><img src='/images/Team-Member-5.jpg' loading='lazy' alt='' className='team-image' />
                            <div className='name-heading-holder'>
                                <h5 className='team-member-name'>Siyuan Jr</h5>
                            </div>
                        </div>
                        <div id='w-node-d184e0fb-fdcd-af09-8265-bc9705e08b83-8c3bb787' className='team-member-content-holder'><img src='/images/Team-Member-4.jpg' loading='lazy' alt='' className='team-image' />
                            <div className='name-heading-holder'>
                                <h5 className='team-member-name'>Reinhart Julian</h5>
                            </div>
                        </div>
                        <div id='w-node-d184e0fb-fdcd-af09-8265-bc9705e08b88-8c3bb787' className='team-member-content-holder'><img src='/images/Team-Member-7.jpg' loading='lazy' alt='' className='team-image' />
                            <div className='name-heading-holder'>
                                <h5 className='team-member-name'>Jane Cooper</h5>
                            </div>
                        </div>
                    </div>
                    <div className='fade-in-move-on-scroll'>
                        <div className='investors-panel'>
                            <p className='large-paragraph'>Our Investors</p>
                            <div className='w-layout-grid investor-grid'>
                                <div className='investor-logo-holder'><img src='/images/Border-Image.svg' loading='lazy' alt='' className='investor-logo' /></div>
                                <div className='investor-logo-holder'><img src='/images/Logo-To-Use-2.svg' loading='lazy' alt='' className='investor-logo' /></div>
                                <div className='investor-logo-holder'><img src='/images/Logo-To-Use-3.svg' loading='lazy' alt='' className='investor-logo' /></div>
                                <div className='investor-logo-holder'><img src='/images/Logo-To-Use-4.svg' loading='lazy' alt='' className='investor-logo' /></div>
                                <div className='investor-logo-holder'><img src='/images/Logo-To-Use-5.svg' loading='lazy' alt='' className='investor-logo' /></div>
                                <div className='investor-logo-holder'><img src='/images/Terra-Logo.svg' loading='lazy' alt='' className='investor-logo' /></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ---------------- Handcrafted / product ---------------- */}
            <div className='section grey'>
                <div className='container'>
                    <div className='w-layout-grid grid-8-col'>
                        <div id='w-node-_761d649c-65e3-8a7f-8baa-19549fe52446-8c3bb787' className='content'>
                            <div id='w-node-_761d649c-65e3-8a7f-8baa-19549fe52447-8c3bb787' className='fade-in-move-on-scroll'>
                                <div className='center-text'>
                                    <h2 className='hero-heading'>Handcrafted  to Manage all your Cash liquidity</h2>
                                    <p id='w-node-_761d649c-65e3-8a7f-8baa-19549fe5244b-8c3bb787'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. At etiam tellus aliquet risus, odio vitae cras viverra elementum.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='fade-in-move-on-scroll'>
                        <div className='about-product-grid-holder'>
                            <div className='w-layout-grid about-product-grid'>
                                <div className='content'>
                                    <div className='product-text-holder'>
                                        <div className='content'>
                                            <h3 className='no-margin-top'>Embodying sustainable practices for the future</h3>
                                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. </p>
                                        </div>
                                        <div className='about-product-holder'>
                                            <div className='fade-in-move-on-scroll'>
                                                <p className='white-heading-text'>Paperless automation</p>
                                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing</p>
                                            </div>
                                            <div className='fade-in-move-on-scroll'>
                                                <p className='white-heading-text'>AWS Microservices Infrastructure</p>
                                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing</p>
                                            </div>
                                            <div className='fade-in-move-on-scroll'>
                                                <p className='white-heading-text'>Work From Home policy</p>
                                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id='w-node-_27b8e8aa-3745-70ab-8b8a-b5a99b8fff20-8c3bb787' className='content'>
                                    <div id='w-node-_8b8e0488-548a-ff3d-ca63-e0fd4266025b-8c3bb787' className='flip-image-holder'><img src='/images/Black-Box-With-Image_1Black-Box-With-Image.webp' loading='lazy' id='w-node-c6a79385-36d0-18f0-449d-d67b1165df6b-8c3bb787' alt='' className='about-product-image' /></div>
                                </div>
                            </div>
                            <div className='w-layout-grid about-product-grid'>
                                <div className='content'>
                                    <div id='w-node-bec7aa51-fb20-76ef-7584-afcbc99baa43-8c3bb787' className='flip-image-holder'>
                                        <div className='gradient-container'><img src='/images/App-About.png' loading='lazy' alt='' className='app-image-inside-gradient' /></div>
                                    </div>
                                </div>
                                <div className='content'>
                                    <div className='product-text-holder'>
                                        <div className='content'>
                                            <h3 className='no-margin-top'>The product methodology</h3>
                                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas massa massa id arcu blandit dignissim contum volutpat dolor</p>
                                        </div>
                                        <div className='about-product-holder'>
                                            <div className='fade-in-move-on-scroll'>
                                                <p className='white-heading-text'>Paperless automation</p>
                                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing</p>
                                            </div>
                                            <div className='fade-in-move-on-scroll'>
                                                <p className='white-heading-text'>AWS Microservices Infrastructure</p>
                                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing</p>
                                            </div>
                                            <div className='fade-in-move-on-scroll'>
                                                <p className='white-heading-text'>Work From Home policy</p>
                                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ---------------- Team leads ---------------- */}
            <div className='section'>
                <div className='container'>
                    <div className='w-layout-grid grid-8-col'>
                        <div id='w-node-_0379962e-2534-b517-b76f-33878a4812b9-8c3bb787' className='content'>
                            <div id='w-node-_0379962e-2534-b517-b76f-33878a4812ba-8c3bb787' className='fade-in-move-on-scroll'>
                                <div className='center-text'>
                                    <h2 className='hero-heading'>Built by leaders in the technology, automotive, and finance industries</h2>
                                    <p id='w-node-_0379962e-2534-b517-b76f-33878a4812be-8c3bb787'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. At etiam tellus aliquet risus, odio vitae cras viverra elementum.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='fade-in-move-on-scroll'>
                        <div className='w-layout-grid team-lead-grid'>
                            <div id='w-node-_2829e8f6-b865-59ab-bd20-a71c4c0dd06f-8c3bb787' className='content'>
                                <div className='team-lead-member-holder'>
                                    <div className='team-lead-member-image-holder'><img src='/images/Unsplash-Image.png' loading='lazy' alt='' className='team-lead-member-image' /></div>
                                    <div className='team-lead-member-content'>
                                        <p className='white-heading-text'>Jane Cooper</p>
                                        <p>Lorem ipsum dolor sit amet,</p>
                                    </div>
                                </div>
                            </div>
                            <div id='w-node-_4de20e24-a19a-a377-f69e-ac7f73a6ff8b-8c3bb787' className='content'>
                                <div className='team-lead-member-holder'>
                                    <div className='team-lead-member-image-holder'><img src='/images/Unsplash-Image-2.png' loading='lazy' alt='' className='team-lead-member-image' /></div>
                                    <div className='team-lead-member-content'>
                                        <p className='white-heading-text'>Wade Warren</p>
                                        <p>Lorem ipsum dolor sit amet,</p>
                                    </div>
                                </div>
                            </div>
                            <div id='w-node-e4f7191b-3954-94cd-dbce-55848879ade9-8c3bb787' className='content'>
                                <div id='w-node-b151216c-cae6-b9fd-f31c-54935d6e1b27-8c3bb787' className='team-lead-member-holder'>
                                    <div className='team-lead-member-image-holder'><img src='/images/Unsplash-Image-3.png' loading='lazy' alt='' className='team-lead-member-image' /></div>
                                    <div className='team-lead-member-content'>
                                        <p className='white-heading-text'>Brooklyn Simmons</p>
                                        <p>Lorem ipsum dolor sit amet,</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ---------------- Shared CTA ---------------- */}
            <CtaSection />
        </>
    )
}

export default About
